export default "__VITE_ASSET__BxotAxDv__"